export class Conversation {
  id: string = null;
  title: string = null;
  members: string[] = [];
  creationDate: string;
  createdBy: string;
  read: boolean;
  lastMessage: string;
  lastMessageDate: string;
  otherUserId?: string;
  otherUserProfile?: string;
  responsesDisabled: boolean;
  organization: string;
  
  constructor(init: Partial<Conversation>) {
    Object.assign(this, init);
  }

  getTitle(currentUser: string): string {
    if (this.title) {
      return this.title
    } else {
      let otherMembers = Object.keys(this.members).filter((userID) => {
        return userID !== currentUser
      });

      if (otherMembers.length === 0) {
        return "Conversation"
      } else if (otherMembers.length === 1) {
        return this.members[otherMembers[0]].name;
      } else if (otherMembers.length > 1) {
        let title = "";
        let addName = otherMembers.slice(0, 3);
        for (let index = 0; index < addName.length; index++) {
          title += `${this.members[addName[index]].name.split(" ")[0]}`;
          if (index < addName.length - 1) {
            title += `, `;
          }
        }
        if (otherMembers.length > 3) {
          title += `...`;
        }
        return title
      }
    }
  }

  getOtherUser(currentUser: string) {
    if (this.otherUserId) {
      return this.otherUserId
    }
    let otherMembers = Object.keys(this.members).filter((userID) => {
      return userID !== currentUser
    });
    this.otherUserId = otherMembers.length ? otherMembers[0] : null
    return this.otherUserId
  }

  getMembers(): string[] {
    return this.members && Object.keys(this.members).length > 0 ? Object.keys(this.members) : null;
  }
}